import { render, staticRenderFns } from "./statistic_trans.vue?vue&type=template&id=168022e3&scoped=true"
import script from "./statistic_trans.vue?vue&type=script&lang=js"
export * from "./statistic_trans.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "168022e3",
  null
  
)

export default component.exports